import { motion } from "framer-motion";
import styled, { keyframes } from "styled-components";

import { BettoBrowseGrid } from "@pages/casino/pages/provider/bettoCollectionElements.js";

export const CARD_VARIANT = {
	GRID: "grid",
	SLIDER: "slider",
};

const shimmer = keyframes`
	0% {
		background-position: 120% 0;
	}
	100% {
		background-position: -120% 0;
	}
`;

export const BettoGameGridMotion = styled(motion.div)`
	width: 100%;
`;

export const BettoSliderBrowseGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 10px;
	width: 100%;

	@media (min-width: 768px) {
		grid-template-columns: repeat(5, minmax(0, 1fr));
	}

	@media (min-width: 1024px) {
		grid-template-columns: repeat(7, minmax(0, 1fr));
	}

	@media (min-width: 1440px) {
		grid-template-columns: repeat(8, minmax(0, 1fr));
	}
`;

export const BettoGameGridPlaceholderCard = styled.div`
	position: relative;
	border-radius: 12px;
	overflow: hidden;
	background: #171c2a;
	isolation: isolate;
	box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.14);

	aspect-ratio: ${({ $variant }) => ($variant === CARD_VARIANT.SLIDER ? "4 / 5" : "1 / 1")};

	&::before {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: inherit;
		background: radial-gradient(
				ellipse 90% 70% at 0% 0%,
				rgba(82, 151, 255, 0.38) 0%,
				transparent 58%
			),
			radial-gradient(
				ellipse 85% 65% at 100% 0%,
				rgba(82, 151, 255, 0.28) 0%,
				transparent 55%
			),
			radial-gradient(
				ellipse 70% 55% at 100% 100%,
				rgba(140, 72, 210, 0.18) 0%,
				transparent 50%
			),
			linear-gradient(180deg, rgba(31, 37, 54, 0.95) 0%, rgba(18, 21, 31, 1) 100%);
		pointer-events: none;
		z-index: 0;
	}

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: inherit;
		background: linear-gradient(
			110deg,
			transparent 30%,
			rgba(255, 255, 255, 0.1) 50%,
			transparent 70%
		);
		background-size: 220% 100%;
		animation: ${shimmer} 1.8s ease-in-out infinite;
		pointer-events: none;
		z-index: 1;
	}

	@media (prefers-reduced-motion: reduce) {
		&::after {
			animation: none;
			opacity: 0.35;
		}
	}
`;

export const BettoGameGridCardMotion = styled(motion.div)`
	width: 100%;
	min-width: 0;
`;

export const gridContainerVariants = {
	hidden: {
		opacity: 0,
		y: 8,
	},
	visible: {
		opacity: 1,
		y: 0,
		transition: {
			duration: 0.28,
			ease: [0.22, 1, 0.36, 1],
			staggerChildren: 0.018,
			delayChildren: 0.015,
		},
	},
	exit: {
		opacity: 0,
		y: 6,
		transition: { duration: 0.18, ease: "easeIn" },
	},
};

export const gridItemVariants = {
	hidden: {
		opacity: 0,
		y: 8,
	},
	visible: {
		opacity: 1,
		y: 0,
		transition: {
			duration: 0.26,
			ease: [0.22, 1, 0.36, 1],
		},
	},
};

export const getGridComponentForVariant = (cardVariant) =>
	cardVariant === CARD_VARIANT.SLIDER ? BettoSliderBrowseGrid : BettoBrowseGrid;

export { BettoBrowseGrid };
